import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { apiConfig } from './api.config';

export const appConfig: ApplicationConfig =
  mergeApplicationConfig(apiConfig);
